import security, { fixDataToServer } from 'stores/security';
import { ClearingEnum, CustomerInfoType, LicenseEnum } from 'types/customer';
import API from 'utils/API';
import http from 'utils/http';

/**
 * @description marsco帐户 可开户拍照列表 Marsco ,在开户协议和开户中需要这个字段
 */
export function getOpenType() {
    return http.get<
        Array<{
            clearing: ClearingEnum;
            license: LicenseEnum;
        }>
    >(API.CUSTOMER.available());
}

// 安全检查
/**
 *
 * @param params tel_code / phone(email) / verify(email 非必须)
 */
export function setPhone(params) {
    return http.post(API.OAUTH.setphone(), { ...params });
}

export function setEmail(params) {
    return http.post(API.OAUTH.setEmail(), { ...params });
}

/**
 * @description 开户
 */
export function openAccount(data: CustomerInfoType) {
    const curData = fixDataToServer(data);

    return http.post<{ customer_id: number }>(API.CUSTOMER.portal(), curData).then(res => res.data);
}

/**
 * @description 修改用户信息
 * @param {object} data 资料项
 * @param {string} modify_type 资料类型
 */
export function modifyCustomerInfo(data: Partial<CustomerInfoType>, modify_type?: string) {
    const curData = fixDataToServer(data);

    return http.put(API.CUSTOMER.modify(), {
        ...curData,
        customer_id: security.currentCustomerId,
        modify_type
    });
}
